import _ from "lodash";
import React from "react";
import classes from "./QuestionBarChartTooltipContent.scss";
import { useI18n } from "Hooks";
import { elevations } from "@toddle-edu/ds-theme";

const QuestionBarChartTooltipContent = ({ payload }) => {
  const { t } = useI18n(["worksheet"]);
  if (!_.isEmpty(payload)) {
    const data = _.get(payload[0], "payload", {});
    const { students, marksMidRange, studentList } = data;

    const isRange = _.includes(marksMidRange, "-");

    return (
      <div
        className={classes.outerTooltipContainer}
        style={elevations["elevation-2B"]}
        role="status"
        aria-live="assertive"
      >
        <div className={classes.tooltipContainer}>
          <div className={classes.tooltipInnerContainer}>
            <div className={classes.studentScoreOverview}>
              <div className={classes.studentCount}>{students}</div>
              <div className={classes.marksRangeContainer}>
                {isRange
                  ? t("worksheet:score_between_range", {
                      range: marksMidRange,
                    })
                  : t("worksheet:score_chart_text", {
                      score: marksMidRange,
                    })}
              </div>
            </div>
            {!_.isEmpty(studentList) ? (
              <div className={classes.studentsContainer}>
                {_.map(studentList, ({ studentMark, studentName }) => (
                  <div className={classes.studentDetailContainer}>
                    <div className={classes.studentNameText}>{studentName}</div>
                    <div className={classes.studentMarkText}>{studentMark}</div>
                  </div>
                ))}
              </div>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
  return null;
};
export default QuestionBarChartTooltipContent;
